import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import UserService from "./services/user/UserService";
import { UserFacingError } from "@/models/helper/UserFacingError";
import { IShift } from "@/models/shift/Shift";
import { Option } from "@/components/multi-select-filter/SelectionFilter";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDateString(dateString: string) {
  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
  const day = date.getDate().toString().padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function formatDate(date: Date | undefined): string {
  if (!date) return "";
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
  const day = date.getDate().toString().padStart(2, "0");
  return `${month}/${day}/${year}`;
}

export function dateFormat(val: string | Date) {
  const date = new Date(val);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  return `${String(date.getDate()).padStart(2, "0")} ${months[date.getMonth()]
    } ${date.getFullYear()}`;
}

export function dateQuery(val: string | Date) {
  const date = new Date(val);
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}

// OLD CODE (Asset Finalize Filter)
// export function getStatusClass(val: string) {
//   if (val.startsWith("Finalized-")) {
//     val = val.split("-")[1];
//   }
//   switch (val) {
//     case "Accepted":
//       return "text-blue-400";
//     case "Present":
//       return "text-green-600";
//     case "Finalized":
//       return "text-green-600";
//     case "Rejected":
//       return "text-red-600";
//     case "Absent":
//       return "text-red-600";
//     case "Pending":
//       return "text-yellow-600";
//     case "Canceled":
//       return "text-amber-600";
//     default:
//       break;
//   }
// }

export function getStatusClass(val: string) {
  if (val.startsWith("Finalized-")) {
    val = val.split("-")[1];
  }
  switch (val) {
    case "Accepted":
      return "text-blue-400";
    case "Present":
      return "text-green-600";
    case "Finalized":
      return "text-green-600";
    case "Check-In Finalized":
      return "text-purple-400";
    case "Check-Out Finalized":
      return "text-cyan-500";
    case "Rejected":
      return "text-red-600";
    case "Absent":
    case "Check-In Absent":
    case "Check-Out Absent":
      return "text-red-600";
    case "Pending":
      return "text-yellow-600";
    case "Canceled":
    case "Check-In Canceled":
    case "Check-Out Canceled":
      return "text-amber-600";
    default:
      break;
  }
}

export async function resolveBorrowerCredentials(credentials: string[]) {
  const { failed, successful } = await UserService.fetchBorrowerData(
    credentials
  );

  if (failed && failed.length > 0) {
    throw new UserFacingError({
      title: "Invalid borrower data.",
      description: `${failed[0].credential}: ${failed[0].reason}`,
    });
  } else {
    return successful;
  }
}

export function convertShiftsToOptions(shifts: IShift[]): Option[] {
  return shifts.map((s) => ({ id: s.id.toString(), name: s.name }));
}
